import { useEffect, useState } from 'react'
import { getProgressForEpisode } from './localStorageProgress'

export const useEpisodeProgress = (episodeId: string) => {
  const [progress, setProgress] = useState(() =>
    getProgressForEpisode(episodeId),
  )

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'podcast_progress' && event.newValue) {
        const allProgress = JSON.parse(event.newValue)
        const newProgress = allProgress[episodeId]
        if (typeof newProgress === 'number') {
          setProgress(newProgress)
        }
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [episodeId])

  return progress
}
